import {Routes} from '@angular/router';
import {ProductChangeComponent} from './product-change/product-change.component';
import {ProductChangeCardviewComponent} from './product-change-cardview/product-change-cardview.component';
import {ProductChangeDetailsComponent} from './product-change-details/product-change-details.component';
import {DeliveryComponent} from './delivery/delivery.component';
import {DeliveryAllItemsComponent} from './delivery-all-items/delivery-all-items.component';
import {SearchResultComponent} from './search-result/search-result.component';
import {SearchSlotComponent} from './search-slot/search-slot.component';
import {DeliveryProductsComponent} from './delivery-products/delivery-products.component';
import {DeliveryProductDetailsComponent} from './delivery-product-details/delivery-product-details.component';
import {TermsOfUseComponent} from './terms-of-use/terms-of-use.component';
import {DeliveryMainProductsComponent} from './delivery-main-products/delivery-main-products.component';
import {ProductChangeSelectionComponent} from './product-change-selection/product-change-selection.component';
import {GotoRedirectComponent} from './goto-redirect/goto-redirect.component';


// Konstrukt notwendig für die Announcements / News Items
export class EmptyComponent {} // NOSONAR

// Reihenfolge ist relevant: Allgemeine Seiten und Fehlerseiten zum Schluss, spezielle Seiten an den Anfang
export const routes: Routes = [
  {
    path: 'product-change',
    component: ProductChangeComponent,
    title: 'page-title.product_change',
    children: [
      { path: '', redirectTo: 'current', pathMatch: 'full' },
      { path: 'current', component: ProductChangeCardviewComponent },
      { path: 'details/:id', component: ProductChangeDetailsComponent }
    ]
  },
  {
    path: 'delivery',
    component: DeliveryComponent,
    title: 'page-title.delivery',
    children: [
      { path: '', redirectTo: 'all-items', pathMatch: 'full' },
      {
        path: 'all-items',
        component: DeliveryAllItemsComponent,
        children: [
          {
            path: ':id',
            component: EmptyComponent,
            title: 'page-title.announcement'
          }
        ]
      },
      {
        path: 'products/:id/product/:product-id',
        component: DeliveryProductDetailsComponent
      },
      { path: 'products/:id', component: DeliveryProductsComponent },
      {
        path: 'main-products/:id/product/:product-id',
        component: DeliveryProductDetailsComponent
      },
      { path: 'main-products/:id', component: DeliveryMainProductsComponent }
    ]
  },

  {
    path: 'download-v2', redirectTo: 'download'
  },

  {
    path: 'download',
    loadChildren: () => import('download-portal').then(m => m.appRoutes)
  },

  {
    path: 'goto',
    children: [
      { path: 'mainrelease-lfu', component: GotoRedirectComponent },
      { path: 'mainrelease', component: GotoRedirectComponent },
      { path: 'sme-sr', component: GotoRedirectComponent },
      { path: 'sme', component: GotoRedirectComponent },
      { path: 'base-sw', component: GotoRedirectComponent },
      { path: 'additional-sw-product', component: GotoRedirectComponent },
      { path: 'additional-sw', component: GotoRedirectComponent },
      { path: 'sme-faktura-rewe', component: GotoRedirectComponent },
      { path: 'sme-faktura', component: GotoRedirectComponent }
      ]
  },

  {
    path: 'home', redirectTo: 'delivery/all-items'
  },
  {
    path: 'search-result',
    component: SearchResultComponent,
    title: 'page-title.search_result'
  },
  {
    path: 'product-change-selection',
    component: ProductChangeSelectionComponent,
    title: 'page-title.product_change_selection'
  },
  {
    path: 'terms-of-use',
    component: TermsOfUseComponent,
    title: 'page-title.terms_of_use'
  },

  { path: '**', redirectTo: 'delivery/all-items' }
];

export const routingComponents = [
  ProductChangeComponent,
  ProductChangeCardviewComponent,
  ProductChangeDetailsComponent,
  DeliveryComponent,
  DeliveryAllItemsComponent,
  DeliveryProductsComponent,
  SearchResultComponent,
  SearchSlotComponent,
  TermsOfUseComponent
];
